import { useState } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE
// boxiaotu主后端API（用于推广员登录）
const BOXIAOTU_API = 'https://api.boxiaotu.cn/api'

export default function ChannelLogin() {
  const [loginType, setLoginType] = useState('agent') // agent 或 partner
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleLogin = async () => {
    if (!phone) { setError('请输入手机号'); return }
    if (!password) { setError('请输入密码'); return }
    setError('')
    setLoading(true)
    
    try {
      let res, data
      
      if (loginType === 'agent') {
        // 区域代理登录 - 需要手机号+密码
        res = await fetch(`${API}/auth/unified-login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone, password, role: 'agent' })
        })
        data = await res.json()
        
        if (data.success) {
          localStorage.setItem('cms_token', data.data.token || data.token)
          localStorage.setItem('cms_user', JSON.stringify(data.data))
          localStorage.setItem('cms_role', 'agent')
          localStorage.setItem('cms_user_id', data.data.agent_id || data.data.id)
          window.location.href = '/cms/?page=partner-store'
          return
        }
      } else {
        // 推广员登录 - 需要手机号+密码
        res = await fetch(`${BOXIAOTU_API}/partners/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone, password })
        })
        data = await res.json()
        
        if (data.success) {
          localStorage.setItem('cms_token', data.token || 'partner_token_' + phone)
          localStorage.setItem('cms_user', JSON.stringify(data.partner))
          localStorage.setItem('cms_role', 'partner')
          localStorage.setItem('cms_user_id', data.partner.id)
          window.location.href = '/cms/?page=partner-center'
          return
        }
      }
      
      // 如果上面失败，显示错误
      setError(data.error || '登录失败')
    } catch (e) {
      setError('网络错误，请稍后重试')
    }
    setLoading(false)
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f2f5' }}>
      <div style={{ background: '#fff', borderRadius: 8, padding: 40, width: 360, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <h2 style={{ textAlign: 'center', marginBottom: 8 }}>推广员/代理登录</h2>
        <p style={{ textAlign: 'center', color: '#999', marginBottom: 24, fontSize: 13 }}>博小兔合作伙伴管理系统</p>
        
        {/* 登录类型切换 */}
        <div style={{ display: 'flex', marginBottom: 24, background: '#f5f5f5', borderRadius: 4, padding: 4 }}>
          <button 
            onClick={() => { setLoginType('agent'); setPassword(''); }}
            style={{ 
              flex: 1, 
              padding: '8px', 
              border: 'none', 
              borderRadius: 4,
              background: loginType === 'agent' ? '#1890ff' : 'transparent',
              color: loginType === 'agent' ? '#fff' : '#666',
              cursor: 'pointer',
              fontSize: 13
            }}
          >
            区域代理
          </button>
          <button 
            onClick={() => { setLoginType('partner'); setPassword(''); }}
            style={{ 
              flex: 1, 
              padding: '8px', 
              border: 'none', 
              borderRadius: 4,
              background: loginType === 'partner' ? '#1890ff' : 'transparent',
              color: loginType === 'partner' ? '#fff' : '#666',
              cursor: 'pointer',
              fontSize: 13
            }}
          >
            推广员
          </button>
        </div>

        {error && (
          <div style={{ background: '#fff2f0', border: '1px solid #ffccc7', color: '#ff4d4f', padding: '10px 12px', borderRadius: 4, marginBottom: 16, fontSize: 13 }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }}>手机号</label>
          <input type="text" placeholder="请输入注册时的手机号" value={phone}
            onChange={e => setPhone(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14, boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }}>密码</label>
          <input type="password" placeholder="请输入密码" value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14, boxSizing: 'border-box' }} />
        </div>

        <button onClick={handleLogin} disabled={loading}
          style={{ width: '100%', padding: '12px', background: loading ? '#ccc' : '#1890ff', color: '#fff', border: 'none', borderRadius: 4, fontSize: 14, cursor: loading ? 'not-allowed' : 'pointer' }}>
          {loading ? '登录中...' : '登录'}
        </button>
      </div>
    </div>
  )
}
